import {Component, inject} from '@angular/core';
import {ApplicationCommonComponent} from "../../../common/application.common.component";
import {ApplicationAppEntityApplicationRead} from "../../../../../../openapi";
import {stages} from "../../contact-data-update.routes";
import {CommonModule} from "@angular/common";
import {NgxMaskDirective} from "ngx-mask";
import {ReactiveFormsModule} from "@angular/forms";
import {RouterLink} from "@angular/router";
import {SpinnerComponent} from "../../../../../../common/spinner/spinner.component";
import {StagesComponent} from "../../../../../../common/stages/stages.component";
import {ValidationErrorsComponent} from "../../../../../../common/validation-errors/validation-errors.component";
import {CurrentDeliveryAddressForm} from "./forms/current-delivery-address.form";

@Component({
  selector: 'app-current-delivery-address-section',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    RouterLink,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [CurrentDeliveryAddressForm],
  templateUrl: './current-delivery-address-section.component.html'
})
export class CurrentDeliveryAddressSectionComponent extends ApplicationCommonComponent {

  public stages = stages;

  public form: CurrentDeliveryAddressForm = inject(CurrentDeliveryAddressForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.updateApplication('inne-dane', this.form.toWriteModel())
    } else {
      this.form.markAllAsTouched();
    }
  }
}
